import { render, staticRenderFns } from "./PsEventFaq.vue?vue&type=template&id=94e9bd28&scoped=true&"
import script from "./PsEventFaq.vue?vue&type=script&lang=js&"
export * from "./PsEventFaq.vue?vue&type=script&lang=js&"
import style0 from "./PsEventFaq.vue?vue&type=style&index=0&id=94e9bd28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e9bd28",
  null
  
)

export default component.exports